/**
 * Created by hp on 2017/8/22.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import {Page, WKError} from '../components';
import {isPC, storage} from '../utils'
import {WKPreload} from '../components/wk';
import {LiveroomVerifyForm, LiveroomVerifyTopBar} from '../components/liveroomVerify';
import '../css/page/LiveroomVerifyPage.css';
import errorImg from '../images/no-source.png';
import config from '../config';


class LiveroomVerifyPage extends Component {
    constructor() {
        super();
        this.renderBottom = this.renderBottom.bind(this);
        this.handleSelectType = this.handleSelectType.bind(this);
        this.handleApplyVerify = this.handleApplyVerify.bind(this);
        this.setStatus = this.setStatus.bind(this)

        this.state = {
            initialized: false,
            selectType: 'person',
            isApplyVerify: false,
            isVerify: false,
            personReq: null,
            companyReq: null,
            liveroom: null,
            status: 'default'
        }
    }

    componentDidMount() {
        document.title = '认证';
        const {liveroom_id} = this.props.params;
        this.setState({liveroomId: liveroom_id})
        this.fetchLiveroomVerify(liveroom_id)
    }

    fetchLiveroomVerify(liveroomId) {
        axios.get(`/api/liveroom/${liveroomId}/verify_info`).then(res => {
            let data = res.data.data;
            // 判断选择类型
            let selectType = data.current_verify ? data.current_verify : 'person';
            // 判断审核状态
            let status = 'default'
            if ((res.data.code === 0 || res.data.code === 3) && data.liveroom.verify_type !== 0) status = 'success' // 0 未认证; 3 上次通过的认证
            if (res.data.code === 1) status = 'review'
            if (res.data.code === 2) status = 'failed'

            // 未认证用户
            if (data.liveroom.verify_type === 0 && status === 'default') {
                let personVerify = storage.getItem('liveroom-verify__person')
                let companyVerify = storage.getItem('liveroom-verify__company')
                if (personVerify) {
                    data.person_req = personVerify
                }
                if (companyVerify) {
                    data.company_req = companyVerify
                }
            }
            this.setState({
                initialized: true,
                isVerify: true,
                personReq: data.person_req,
                companyReq: data.company_req,
                selectType,
                status
            }, () => {
                if (status === 'failed' || res.data.code === 3) {
                    this.page.showAlert(res.data.msg)
                }
            });
        }).catch(error => {
            let tips = '';
            console.log(error)
            if (error.response && error.response.status === 403) {
                tips = '你不是管理员';
            } else {
                tips = '页面不存在';
            }
            this.props.dispatch({
                type: 'ERROR_SHOW',
                payload: {
                    tips: tips,
                    img: errorImg,
                    href: '/account/?fr=error',
                    btn: '回到个人中心'
                }
            });
        });
    }

    renderBottom() {
        // 如果是pc，超链接用新标签打开
        const blankAttr = isPC() ? { target: '_blank' } : {}
        return (
            <div className="verify-bottom">
                <div className="verify-description">
                    <p className="title">认证后的店铺会有以下特权</p>
                    <p>1. 独有官方认证</p>
                    <p>2. 特权专享，推广资源优先享受</p>
                    {this.state.selectType === 'company' &&
                    <div>
                        <p>3. 个性化包装，品牌微课专题策划</p>
                        <p>4. 促成优质讲师和机构强强联合</p>
                    </div>
                    }
                </div>

                <div className="verify-tips">
                    <p className="title">申请须知</p>
                    <p>1. 您已阅读
                        <a className="contact" {...blankAttr} href={`${config.WK_GW}/secondary/protocol.html`}>《荔课平台用户协议》</a>
                    </p>
                    <p>2. 荔课会对您个人信息进行保密</p>
                    <p>3. 如需帮助或加急审核，请点击添加您的<a className="contact" {...blankAttr} href="/activity/servicepage/">客户经理</a></p>
                </div>
            </div>
        )
    }

    handleSelectType(type) {
        this.setState({selectType: type});
    }

    handleApplyVerify() {
        this.setState({isVerify: false}, () => {
            this.page.showAlert('提交成功，请稍后', () => {
                this.fetchLiveroomVerify(this.state.liveroomId)
            })
        })
    }

    setStatus(status) {
        this.setState({status})
    }

    render() {
        const {selectType, isApplyVerify, initialized, personReq, companyReq, status, isVerify} = this.state;
        const {liveroom_id} = this.props.params;
        const {error} = this.props;

        if (error.showError) {
            return <div className="wk-inner-page"><WKError/></div>
        }

        if (!initialized) {
            return <WKPreload />
        }

        return (
            <Page parent={this} className="liveroom-verify-page">
                <div className="wk-inner-page">
                    {!isApplyVerify &&
                    <div>
                        <LiveroomVerifyTopBar status={status} selectType={selectType} handleChange={this.handleSelectType}/>
                        <LiveroomVerifyForm isVerify={isVerify} status={status} personReq={personReq} companyReq={companyReq} selectType={selectType} handleVerify={this.handleApplyVerify} liveroomId={liveroom_id}/>
                        {this.renderBottom()}
                    </div>
                    }
                </div>
            </Page>
        )
    }
}

export default connect((state) => ({
    account: state.account,
    error: state.error,
}))(LiveroomVerifyPage)



// WEBPACK FOOTER //
// ./src/pages/LiveroomVerifyPage.js